import { Controller } from "react-hook-form"
import { FilePenLine } from "lucide-react"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"
import type { UserEventCategory } from "@/services/api/cronos/user/events/get-all"
import { useFormContext } from "react-hook-form"
import useUserEventSideSheet from "@/modules/calendar/stores/use-user-event-side-sheet"
import eventCategories from "@/modules/calendar/constants/event-categories"
import getEventCategoryInfo from "@/modules/calendar/utils/get-event-category-info"

export default function EventCategory() {
  const { isDetails } = useUserEventSideSheet()
  const { setValue, control } = useFormContext()

  return (
    <div className="flex w-full items-center justify-start">
      <Controller
        name="category"
        control={control}
        render={({ field }) => (
          <Popover>
            <PopoverTrigger
              asChild
              disabled={isDetails}
              className={`${isDetails ? "pointer-events-none" : ""}`}
            >
              <div
                className={`flex w-auto max-w-full items-center justify-start gap-3 ${
                  isDetails ? "cursor-default" : "cursor-pointer"
                }`}
              >
                <FilePenLine className="!size-5 text-gray-500" />
                <div className="flex w-full items-center justify-start gap-1 text-gray-600">
                  <span className="ml-[3px] text-sm font-normal">Categoría:</span>
                  <span className="space-x-1.5 text-sm font-semibold first-letter:capitalize">
                    <span>{getEventCategoryInfo(field.value as UserEventCategory).icon}</span>
                    <span>{getEventCategoryInfo(field.value as UserEventCategory).label}</span>
                  </span>
                </div>
              </div>
            </PopoverTrigger>
            <PopoverContent className="mt-1 w-full min-w-[200px] p-0" align="start">
              <div className="w-full">
                {eventCategories.map((category) => (
                  <div
                    key={category}
                    className={`flex cursor-pointer items-center gap-2 p-[5px] hover:bg-gray-100 ${
                      field.value === category ? "bg-primary-100" : ""
                    }`}
                    onClick={() => {
                      setValue("category", category)
                      document.dispatchEvent(new KeyboardEvent("keydown", { key: "Escape" }))
                    }}
                  >
                    <span>{getEventCategoryInfo(category).icon}</span>
                    <span>{getEventCategoryInfo(category).label}</span>
                  </div>
                ))}
              </div>
            </PopoverContent>
          </Popover>
        )}
      />
    </div>
  )
}
